import { useStore } from '@/app/providers/store';

/**
 * 检测是否有任何全局弹窗处于打开状态。
 *
 * 覆盖范围：
 * - GlobalModalStore（所有 ModalType）
 * - ReferenceModal（创建/编辑主体弹窗）
 * - CreationDetail（路由弹窗，以 creationDetailConfig 作为近似判断）
 *
 * 局部弹窗（组件内 useState 控制的 crop modal 等）不在此范围内，
 * 由各表单通过 disabled prop 自行管理。
 */
export function useHasAnyModalOpen(): boolean {
  return useStore((state) => {
    const hasGlobalModal = Object.values(state.modals).some((v) => v !== null);
    const hasReferenceModal = state.referenceModalOpen;
    const hasCreationDetail = state.creationDetailConfig !== null;

    return hasGlobalModal || hasReferenceModal || hasCreationDetail;
  });
}
